var _style, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGtmProcessSpinnerWhiteB2S = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "gtm-process-spinner-white-b-2s_svg__el_vSCgDoIx3",
  viewBox: "-6 -2 94 94"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@-webkit-keyframes kf_el_ruD27vUZMd_an_E--iARsyv{0%{-webkit-transform:translate(41px,45px) rotate(0deg) translate(-41px,-45px);transform:translate(41px,45px) rotate(0deg) translate(-41px,-45px)}to{-webkit-transform:translate(41px,45px) rotate(360deg) translate(-41px,-45px);transform:translate(41px,45px) rotate(360deg) translate(-41px,-45px)}}@keyframes kf_el_ruD27vUZMd_an_E--iARsyv{0%{-webkit-transform:translate(41px,45px) rotate(0deg) translate(-41px,-45px);transform:translate(41px,45px) rotate(0deg) translate(-41px,-45px)}to{-webkit-transform:translate(41px,45px) rotate(360deg) translate(-41px,-45px);transform:translate(41px,45px) rotate(360deg) translate(-41px,-45px)}}#gtm-process-spinner-white-b-2s_svg__el_vSCgDoIx3 *{-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:cubic-bezier(0,0,1,1);animation-timing-function:cubic-bezier(0,0,1,1)}")), /*#__PURE__*/React.createElement("g", {
  style: {
    WebkitAnimationFillMode: "backwards",
    animationFillMode: "backwards",
    WebkitTransform: "translate(41px,45px) rotate(0deg) translate(-41px,-45px)",
    transform: "translate(41px,45px) rotate(0deg) translate(-41px,-45px)",
    WebkitAnimationName: "kf_el_ruD27vUZMd_an_E--iARsyv",
    animationName: "kf_el_ruD27vUZMd_an_E--iARsyv",
    WebkitAnimationTimingFunction: "cubic-bezier(0,0,1,1)",
    animationTimingFunction: "cubic-bezier(0,0,1,1)"
  }
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  "data-animator-group": "true",
  "data-animator-type": 1,
  style: {
    fill: "#fff"
  }
}, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  id: "gtm-process-spinner-white-b-2s_svg__el_WBPP0OMhmm",
  cx: 41.5,
  cy: 7.5,
  r: 9
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  id: "gtm-process-spinner-white-b-2s_svg__el_h2vVpLS4lU",
  cx: 7.5,
  cy: 26.5,
  r: 9
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  id: "gtm-process-spinner-white-b-2s_svg__el_NsV30AeZ3I",
  cx: 74.5,
  cy: 26.5,
  r: 9
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  id: "gtm-process-spinner-white-b-2s_svg__el_cCOrJEkOra",
  cx: 41.5,
  cy: 82.5,
  r: 9
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  id: "gtm-process-spinner-white-b-2s_svg__el_iXBEf2lGU4",
  cx: 7.5,
  cy: 63.5,
  r: 9
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  id: "gtm-process-spinner-white-b-2s_svg__el_qf7Sncj3Sg",
  cx: 74.5,
  cy: 63.5,
  r: 9
})))));
export { SvgGtmProcessSpinnerWhiteB2S as ReactComponent };
export default __webpack_public_path__ + "img/gtm-process-spinner-white-b-2s.da597c053fc50aaaac9ae2da6609ba60.svg";